export const COMMAND_ARGS_NORMAL_FIELD_KEYS = {
  shellType: 'commandArgsNormal.shellType',
  commands: 'commandArgsNormal.commands',
  args: 'commandArgsNormal.args',
} as const;

export const COMMAND_ARGS_NORMAL_FIELD_KEY_LIST = Object.values(COMMAND_ARGS_NORMAL_FIELD_KEYS);
